import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Grid , Icon , Header , Card , Button } from 'semantic-ui-react';
import { amendCart } from '../../actions/quoteActions';
import wifiPrinter from '../../assets/pricing/printer_80mm.png';
import dorPrinter from '../../assets/pricing/printer_dot.png';
import cashDrawer from '../../assets/pricing/cashDrawer.png';
import singleMonPOS from '../../assets/pricing/singleMonPosTerminal.png';
import dualMonPOS from '../../assets/pricing/dualMonPosTerminal.png';
import dualMonPOS12 from '../../assets/pricing/dualMonPOS12.png';
import sunmiV1 from '../../assets/pricing/sunmi_v1.png';
import sunmiM1 from '../../assets/pricing/sunmi_m1.png';
import sunmiT1 from '../../assets/pricing/sunmi_t1.png';

const styles = {
  mainWrapper : {
    paddingRight : '3.5%'
  },
  section : {
    marginTop : '20px'
  }
}

class HardwareDisplay extends Component {
  constructor(props){
    super(props);
    const { string } = props;
    this.state = {
      products : {
				sunmiSeries : [
					{ header : 'sunmiV1' , price : 2500 , desc : 'sunmiV1Desc' , image : sunmiV1 },
					{ header : 'sunmiM1' , price : 1500 , desc : 'sunmiM1Desc' , image : sunmiM1 },
					{ header : 'sunmiT1' , price : 3500 , desc : 'sunmiT1Desc' , image : sunmiT1 }
				],
        printer : [
          { header : 'WifiThermalPrinter58mm' , price : string['WifiThermalPrinter58mmPrice'] , desc : 'WifiPrinterDesc' , image : wifiPrinter },
          { header : 'WifiThermalPrinter80mm' , price : string['WifiThermalPrinter80mmPrice'] , desc : 'WifiPrinterDesc' , image : wifiPrinter },
          { header : 'WifiDotMatrixPrinter76mm' , price : string['WifiThermalPrinter80mmPrice'] , desc : 'WifiPrinterDesc' , image : dorPrinter },
          { header : 'EthernetThermalPrinter58mm' , price : string['EthernetThermalPrinter58mmPrice'] , desc : 'EthernetPrinterDesc' , image : wifiPrinter },
          { header : 'EthernetThermalPrinter80mm' , price : string['EthernetThermalPrinter80mmPrice'] , desc : 'EthernetPrinterDesc' , image : wifiPrinter },
          { header : 'EthernetDotMatrixPrinter76mm'  , price : string['EthernetDotMatrixPrinter76mmPrice'] , desc : 'EthernetPrinterDesc' , image : dorPrinter}
        ],
        posTerminal : [
          { header : 'SingleMonitorPOS15inch' , price : 3000 , desc : 'SingleMonitorDesc' , image : singleMonPOS }
        ],
        cashDrawer : [
          { header : 'cashDrawerAuto' , price : 500 , desc : 'cashDrawerDesc' , image : cashDrawer }
        ]
      }
    }
  }
  _renderProductSection(sectionKey,section){
    const { string , amendCart } = this.props;
    return(
      <div style={styles.section} key={sectionKey}>
        <Header>{string[sectionKey]}</Header>
        <Card.Group itemsPerRow={3} className="stackable">
          {section.map((product)=>
            <Card
              image={product.image}
              meta={`${string['price']} : ${string[product.header+'Price']} ${string['currency']}`}
              key={product.header}
              header={string[product.header]}
              description={string[product.desc]}
              extra={
                <Grid>
                  <Grid.Column className='ui two buttons computer only'>
                    <Button basic color='green' onClick={()=>amendCart('add','hardware',product)}><Icon name="plus"/></Button>
                    <Button basic color='red' onClick={()=>amendCart('minus','hardware',product)}><Icon name="minus"/></Button>
                  </Grid.Column>
                </Grid>
              }
            />
          )}
        </Card.Group>
      </div>
    )
  }
  render(){
    const { products } = this.state;
    return (
      <Grid.Column style={styles.mainWrapper} width={12}>
        {Object.keys(products).map((sectionKey)=>this._renderProductSection(sectionKey,products[sectionKey]))}
      </Grid.Column>
    );
  }
}

function mapStateToProps(state) {
  return {
    string : state.preference.string
  }
}

const mapDispatchToProps = (dispatch)=>bindActionCreators({ amendCart },dispatch)

export default connect(mapStateToProps,mapDispatchToProps)(HardwareDisplay)



/** WEBPACK FOOTER **
 ** ./src/containers/price/hardwareDisplay.js
 **/